import { Injectable, Injector } from '@angular/core';
import { Params } from '@angular/router';
import { WORKSPACE_RESOURCE_TYPE, WORKSPACE_RESOURCE_PROVIDER } from 'app/services/globals';
import { Observable, BehaviorSubject } from 'rxjs';
import { IPrimaryResourceUrlInformationService } from './interfaces/IPrimaryResourceUrlInformationService';
import { UrlInformationBaseService } from './url-information-base.service';

@Injectable({
    providedIn: 'root'
})
export class WorkspaceUrlInformationService extends UrlInformationBaseService implements IPrimaryResourceUrlInformationService {

    public hasPermission$: BehaviorSubject<boolean> = new BehaviorSubject(undefined);

    public get workspaceId(): string {
        return this.resourceId;
    }
    // used only in integration tests
    public set workspaceId(value: string) {
        this.resourceId = value;
    }
    public get workspaceName(): string {
        return this.resourceName;
    }
    // used only in integration tests
    public set workspaceName(value: string) {
        this.resourceName = value;
    }
    public get workspaceTags(): { [propertyName: string]: string } {
        return this.resourceTags;
    }

    public get isWorkspaceProvided(): boolean {
        return this.isResourceProvided;
    }

    public get workspaceLocation(): Observable<string> {
        return this.resourceLocation$;
    }

    public resourceProviderName = WORKSPACE_RESOURCE_PROVIDER;
    public resourceType = WORKSPACE_RESOURCE_TYPE;
    public resourceTypeNamesInSearch = ['Workspace', 'workspace'];

    constructor(injector: Injector) {
        super(injector);
    }

    public setWorkspaceLocation(location: string): void {
        this.setResourceLocation(location);
    }

    public setWorkspaceInfo(queryParams: Params): void {
        this.setResourceInfo(queryParams);
    }

    public isWorkspaceChanged(queryParams: Params): boolean {
        const workspaceIdOptions = this.resourceTypeNamesInSearch.map((item) => queryParams[item]).filter((item) => !!item);
        if (workspaceIdOptions[0]) {
            return !!this.workspaceId && this.workspaceId.toLowerCase() !== decodeURIComponent(workspaceIdOptions[0]).toLowerCase();
        }

        return true;
    }
}
